<template>
    <div class="videoWrapper">
        <video ref="videoPlayer" class="video-js" preload="auto"></video>
    </div>
</template>
<script>
import videojs from "video.js";
import apiSvc from "../../services/api";

export default {
    name: "VideoPlayer",
    props: {
        startAt: {
            type: Number,
            default: 0
        },
        options: {
            type: Object,
            default() {
                return {
					controls:false
				};
            }
        },
        sessionData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            player: null
        };
    },
    mounted() {
        const videoElement = this.$refs.videoPlayer;

        this.player = videojs(videoElement, this.options, () => {

			
            // console.log("player ready");

            this.player.on("loadedmetadata", () => {
                if (this.startAt && this.startAt < videoElement.duration) {
                    if (0 <= this.startAt) {
                        videoElement.currentTime = this.startAt;
                    }
                }
            });

            this.player.on("canplay", () => {
                // console.log("player play");
                // this.player.play();
            });

            this.player.on("play", () => {
                this.logVideoPlay();
            });

            this.player.on("ended", () => {
                // console.log("player ended");

                this.player.exitFullscreen();
                this.player.hasStarted(false);
            });
        });
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }

        if (document.pictureInPictureElement) {
            document.exitPictureInPicture();
        }
    },
    methods: {
        logVideoPlay() {
            const uid = this.$store.getters.user.id;
            const username = this.$store.getters.user.username;
            const name = this.$store.getters.user.name;
            const videoURL = this.options.sources[0].src;
            const lastSlashIndex = videoURL.lastIndexOf("/");
            const videoName = videoURL.substring(lastSlashIndex);
            let insightId;
            let insightTitle;
            console.log(this.$props);
            if (this.$props.sessionData) {
                insightId = this.$props.sessionData.insightId
                    ? this.$props.sessionData.insightId
                    : null;
                insightTitle = this.$props.sessionData.title
                    ? this.$props.sessionData.title
                    : null;
            }

            const logData = {
                type: `VideoView`,
                uid,
                username,
                name,
                videoURL,
                videoName,
                insightId,
                insightTitle
            };

            apiSvc
                .appendLogEntry(logData)
                .then(res => console.log(res))
                .catch(err => console.log(err));
        }
    }
};
</script>
<style lang="scss">
@import "../../../node_modules/video.js/dist/video-js.css";
@import "../../styles/components/video.scss";
</style>